import { useEffect } from 'react';
import { CheckboxProps, FormControlLabel, SxProps } from '@mui/material';
import sendEvent from 'utils/sendEvent';
import { errorInputEvent } from 'utils/events';
import { Color } from 'utils/getColor';
import CheckboxWrapper from './styled/CheckboxWrapper';
import ErrorMessage from './styled/ErrorMessage';
import StyledCheckbox from './styled/StyledCheckbox';

export interface ICheckbox extends CheckboxProps {
  label: string;
  labelSx?: SxProps;
  errors?: string[] | string;
  touched?: boolean;
  centeredLabel?: boolean;
  addEvent?: () => void;
  labelText?: string;
  unCheckedEvent?: boolean;
}

const getErrorMessage = (errors: string[] | string) => {
  if (typeof errors === 'string') {
    return errors;
  }
  return errors[0];
};

const Checkbox = ({
  label,
  errors,
  touched,
  labelSx,
  centeredLabel,
  addEvent,
  labelText,
  unCheckedEvent,
  ...props
}: ICheckbox) => {
  const hasError = touched && errors && errors.length;
  const { value } = props;
  const color: Color = touched
    ? errors && errors.length
      ? 'error'
      : 'success'
    : undefined;

  useEffect(() => {
    if (addEvent) {
      if ((value && !unCheckedEvent) || (!value && unCheckedEvent)) {
        addEvent();
      }
    }
  }, [value]);
  useEffect(() => {
    if (hasError && touched && labelText) {
      const errorMessage = getErrorMessage(errors);
      sendEvent({
        labelText: `${labelText}: ${errorMessage}`,
        ...errorInputEvent
      });
    }
  }, [hasError, touched]);

  return (
    <CheckboxWrapper $centeredLabel={centeredLabel}>
      <FormControlLabel
        control={<StyledCheckbox {...props} color={color} />}
        label={label}
        sx={labelSx}
      />
      {hasError && <ErrorMessage>{getErrorMessage(errors)}</ErrorMessage>}
    </CheckboxWrapper>
  );
};

export default Checkbox;
